import React from 'react';
import StickyBox from 'components/StickyBox';
import { jsx as _jsx } from "react/jsx-runtime";
function StickyEditorPageHeaderWrapper(_ref) {
  var _ref$mb = _ref.mb,
    mb = _ref$mb === void 0 ? 'm' : _ref$mb,
    distance = _ref.distance,
    children = _ref.children;
  return /*#__PURE__*/_jsx(StickyBox, {
    placement: "top",
    borderRadius: "large",
    mb: mb,
    distance: distance,
    children: children
  });
}
export default StickyEditorPageHeaderWrapper;